import { ClaimAthleteProfile } from '@/components/talent/ClaimAthleteProfile';

const ClaimAthleteProfilePage = () => {
  return <ClaimAthleteProfile />;
};

export default ClaimAthleteProfilePage;
